import { AppDispatch } from '@typings/redux';
import { useEnvironment } from 'components/shared/hooks/useEnvironment/useEnvironment';
import { useCallback, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { exchangeAuthCode } from 'utils/auth/fetchAccessToken';
import { checkAuth } from 'store/auth/auth.action';
import { AuthActionType } from 'store/auth/auth.actionType';

export const useAuthCode = (authCode: string) => {
  const [isResolved, setResolved] = useState<boolean>(!authCode);
  const [isAuthorized, setAuthorized] = useState<boolean>(false);
  const [error, setError] = useState<string>();
  const dispatch = useDispatch<AppDispatch>();
  const { origin } = useEnvironment();

  const authorize = useCallback(async () => {
    // Define the onSuccess callback that will be called only after 204 response
    const onSuccess = async () => {
      const checkAuthResult = await dispatch(checkAuth());

      // Check if /me call was successful
      if (checkAuthResult.type !== AuthActionType.CHECK_AUTH_SUCCESS) {
        throw new Error('AUTH.FAILED');
      }
    };

    const { error } = await exchangeAuthCode(authCode, origin, onSuccess);

    if (error) {
      setError(error);
    } else {
      // If we get here, both /auth (204) and /me (success) completed successfully
      setAuthorized(true);
    }

    setResolved(true);
  }, [authCode, dispatch, origin]);

  useEffect(() => {
    if (authCode) {
      !isResolved && authorize();
    } else {
      setError('AUTHORIZATION.NOTIFICATIONS.SIGN_IN_ERROR');
    }
  }, [authCode, authorize, isResolved, origin]);

  return {
    resolved: isResolved,
    authorized: isAuthorized,
    error,
  };
};
